export const designTokens = {
  bgPage: "#F5F6F8",
  bgCard: "#FFFFFF",
  bgOverlay: "rgba(255,255,255,0.9)",
  border: "#E4E7EC",
  textPrimary: "#101828",
  textSecondary: "#667085",
  accent: "#ED1C24",
  accentHover: "#C91018",
  info: "#2E90FA",
  radiusInput: 8,
  radiusCard: 10,
  shadow: "0 1px 2px rgba(16,24,40,0.04)",
  floatingShadow: "0 8px 24px rgba(16,24,40,0.12)",
  fontFamily: "Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif",
};
